/* eslint-disable */
import axios from 'axios'

const SERVICEPUBLICMSGAPI = '/Service/public/msg'

function msgTYPE(senddata) {
  const url = `${SERVICEPUBLICMSGAPI}/type?status=${senddata.status}&uuid=${senddata.uuid}`
  return new Promise(function (resolve, reject) {
    axios.get(url).then(
      m => {
        resolve(m.data)
      }
    ).catch(function (err) {
      reject(err)
    })
  })
}

export default {
  msgTYPE
}


// WEBPACK FOOTER //
// ./src/common/ajax/API/SERVICEPUBLICMSGAPI.js